import { useContext } from "react";
import { Features } from "../../api/ApiTypes";
import { SessionContext } from "./SessionContext";

export const useFeatureFlag = <Key extends keyof Features>(flag: Key): Features[Key] => {
  const { session } = useContext(SessionContext);
  const features = session?.features;
  if (features == null) return false as Features[Key];
  return features[flag];
};
